// extracted by mini-css-extract-plugin
module.exports = {"app__loader--funkita":"App_app__loader--funkita__11PVJ","app__loader--funkytrunks":"App_app__loader--funkytrunks__116jG"};